/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_1_SolutionInputs */

const es_home_usecases_item_1_solution = /** @type {(inputs: Home_Usecases_Item_1_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscá: 'contrato cliente XYZ modificado en enero'. Obtenés: El documento exacto con historial de versiones. De 20 minutos a 10 segundos.`)
};

const en_home_usecases_item_1_solution = /** @type {(inputs: Home_Usecases_Item_1_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search: 'client XYZ contract modified in January'. Get: The exact document with version history. From 20 minutes to 10 seconds.`)
};

/**
* | output |
* | --- |
* | "Search: 'client XYZ contract modified in January'. Get: The exact document with version history. From 20 minutes to 10 seconds." |
*
* @param {Home_Usecases_Item_1_SolutionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_1_solution = /** @type {((inputs?: Home_Usecases_Item_1_SolutionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_1_SolutionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_1_solution(inputs)
	return en_home_usecases_item_1_solution(inputs)
});
export { home_usecases_item_1_solution as "home.usecases.item_1_solution" }